import React from 'react';
import { ClipboardList } from 'lucide-react';
import { Callout } from '@/shared/ui';
import styles from './RecommendationsBanner.module.css';

interface Props {
  count: number;
  onClick: () => void;
}

export function RecommendationsBanner({ count, onClick }: Props) {
  if (count === 0) return null;

  return (
    <Callout
      icon={ClipboardList}
      variant="warning"
      onClick={onClick}
      actions={<span className={styles.link}>Review in Campaigns →</span>}
    >
      <strong className={styles.count}>
        {count} recommendation{count === 1 ? '' : 's'}
      </strong>{' '}
      ready for your review
    </Callout>
  );
}
